import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/solid";
import React, { useState } from "react";

const FAQs = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What are the core values of GAM-IND?",
      answer: "GAM-IND is founded on principles of inclusivity and independence. We are an apolitical, non-partisan organization with no religious, ethnic, or socio-political affiliations. Our focus is purely on supporting and empowering Gambian students in abroad. By joining us, you'll be part of a diverse, inclusive community dedicated to mutual support and growth."
    },
    {
      question: "Who can join the Gambian Students Association in India?",
      answer:
        "Any Gambian student currently studying in India or alumni who have studied in India can join our association. We welcome students from all academic levels and fields of study.",
    },
    {
      question: "How can I become a member of the association?",
      answer:
        "To become a member, you can fill out the registration form on our website. Once your application is reviewed and approved, you'll receive a confirmation email with further instructions.",
    },
    {
      question: "What benefits do I get from joining the association?",
      answer:
        "Members enjoy various benefits including academic support, networking opportunities, competitions, cultural events, career development workshops, and a strong support system under the association's umbrella either financially or any kind while studying in India.",
    },
    {
      question: "Are there any membership fees?",
      answer:
        "We have a nominal annual membership fee which ₹1000.0 that helps us organize events and provide services to our members. The exact amount and payment details will be provided after the registration process.",
    },
    {
      question: "How often does the association organize events?",
      answer:
        "We organize several events throughout the year, including Independence celebrations, Inter-State Debate and Sport Championship, and Student Week Celebration. The frequency may vary, but we aim to have at least one major event each quarter.",
    },
    {
      question: "Can the association provide guidance for new Gambian students coming to India?",
      answer:
      "Yes, absolutely! Our association offers comprehensive guidance to new Gambian students coming to India. We can assist with pre-arrival information, accommodation advice, networking and cultural adaptation. We also plan to provide a mentorship program where new students will paired with experienced members who can offer personalized support and advice throughout their educational journey in India.",
    },
    {
      question: "How does GAM-IND support student welfare and development?",
      answer: "GAM-IND is committed to improving the quality of life and welfare of Gambian students in India. We organize development programs, training sessions, and awareness initiatives that contribute to both personal and collective growth. By joining us, you'll have access to these valuable resources designed to enhance your educational experience and personal development."
    },
    {
      question: "What cultural opportunities does GAM-IND offer?",
      answer: "One of our primary goals is to promote Gambian culture in India. By joining GAM-IND, you'll have the opportunity to participate in cultural events, share your heritage with others, and stay connected to your roots while studying abroad. It's a great way to combat homesickness and educate others about The Gambia."
    },
    {
      question: "How does GAM-IND collaborate with the Gambian Embassy in Delhi?",
      answer: "We work closely with the Gambian Embassy in Delhi to address important issues affecting Gambian students in India. This collaboration allows us to tackle a wide range of socioeconomic challenges. As a member, you'll benefit from this direct line of communication with official representatives through the association, ensuring your concerns are heard and addressed."
    },
    {
      question: "What kind of support network does GAM-IND provide?",
      answer: "GAM-IND serves as a unifying platform for all Gambian students in India. By joining us, you become part of a strong support network that can help you navigate the challenges of studying abroad. We focus on combating negative experiences and promoting positive actions that contribute to your well-being and success in India."
    },
    {
      question: "How does GAM-IND contribute to personal and professional growth?",
      answer: "We prioritize capacity building as a key to empowerment and economic growth. Our activities and programs are designed to equip you with skills and knowledge crucial for self-empowerment and sustainable livelihood development. Joining GAM-IND gives you access to these valuable opportunities for personal and professional advancement."
    },
    
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="space-y-1">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="border border-gray-200 rounded-lg overflow-hidden"
        >
          <button
            className="flex justify-between items-center w-full p-4 text-left bg-white hover:bg-gray-50 focus:outline-none"
            onClick={() => toggleFAQ(index)}
          >
            <span className="font-medium text-xl font-bold text-gray-900">
              {faq.question}
            </span>
            {openIndex === index ? (
              <ChevronUpIcon className="w-5 h-5 text-tomato" />
            ) : (
              <ChevronDownIcon className="w-5 h-5 text-tomato" />
            )}
          </button>
          <div
            className={`px-4 py-3 bg-gray-50 ${
              openIndex === index ? "block" : "hidden"
            }`}
            style={{
              maxHeight: openIndex === index ? "1000px" : "0",
              transition: "max-height 0.5s ease-in-out",
              overflow: "hidden",
            }}
          >
            <p className="text-gray-700">{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQs;
